import React from "react";
import RoleForm from "./RoleForm";

export default function EditRoles() {
  return <RoleForm type="Edit" />;
}
